import request from "@/utils/request";

const ACTIVE_BASEURL = process.env.VUE_APP_ACTIVE_BASEURL;

/**
 * 获取积分赛列表
 * @param projectId 项目ID
 * @param matchSeason 赛季： 第 matchSeason 赛季
 * @param matchGroup 赛事组别：1 勇武组，2 纵横组，3 无极组
 */
export function getPointRacesListApi({
  projectId,
  matchSeason,
  matchGroup,
  page,
  pageRows,
}) {
  const formData = new FormData();
  formData.append("project_id", projectId || 107);
  formData.append("source_mod", "web");
  formData.append("match_season", matchSeason);
  formData.append("match_group", matchGroup);
  formData.append("page", page);
  formData.append("page_rows", pageRows);
  return request({
    url: `${ACTIVE_BASEURL}/match/pointRaces/list`,
    method: "post",
    data: formData,
  });
}

/**
 * 获取淘汰赛列表
 * @param projectId 项目ID
 * @param matchSeason 赛季： 第 matchSeason 赛季
 * @param matchGroup 赛事组别：1 勇武组，2 纵横组，3 无极组
 * @param matchSession 场次
 * @param matchZone 赛区
 */
export function postMatchKnockoutList({
  projectId,
  matchGroup,
  matchSeason,
  matchSession,
  matchZone,
}) {
  const formData = new FormData();
  formData.append('project_id', projectId || 107);
  formData.append('match_group', matchGroup);
  formData.append('match_season', matchSeason);
  formData.append('match_session', matchSession);
  formData.append('match_zone', matchZone);
  return request({
    url: `${ACTIVE_BASEURL}/match/knockout/list`,
    method: 'post',
    data: formData,
  });
}


/**
 * 获取冠军赛列表
 * @param projectId 项目ID
 * @param matchSeason 赛季： 第 matchSeason 赛季
 * @param matchGroup 赛事组别：1 勇武组，2 纵横组，3 无极组
 * @param matchSession 场次
 * @param matchZone 赛区
 */
export function postMatchChampionList({
  projectId,
  matchGroup,
  matchSeason,
  matchSession,
  matchZone,
}) {
  const formData = new FormData();
  formData.append('project_id', projectId || 107);
  formData.append('match_group', matchGroup);
  formData.append('match_season', matchSeason);
  formData.append('match_session', matchSession);
  formData.append('match_zone', matchZone);
  return request({
    url: `${ACTIVE_BASEURL}/match/champions/list`,
    method: 'post',
    data: formData,
  });
}
